/* globals data, serverParams */
import Table from 'bam-node-savant-table/table'

import { headers, secondaryHeaders } from './headers'
import { slideUp, slideDown } from '../utils/leaderboard-drawer-helpers'

const { is_team_type, entity_code, team, splitYears, target_base } =
    serverParams

const tableDivId = 'catcher_throwing_table'

let currentData = data.slice()

function loadTable(data, expanded = false) {
    const width = document.getElementById(tableDivId).offsetWidth
    let repeatHeader = false
    if (width <= 768) {
        repeatHeader = 15
    }
    const defaultSort = document.getElementById('sort').value
    const defaultSortDirection = document.getElementById('sortDir').value

    let selectedHeaders = expanded ? headers.expanded : headers.normal
    const selectedSecondaryHeaders = expanded
        ? secondaryHeaders.expanded
        : secondaryHeaders.normal

    if (entity_code === 'League') {
        selectedHeaders = selectedHeaders.slice(0, selectedHeaders.length - 1)
    }

    if (target_base === 'All') {
        // If we're accounting for all bases, we don't want to include the distance to target / pop time columns.
        selectedHeaders = selectedHeaders.filter(
            (elem) =>
                elem.field !== 'distance_to_target' && elem.field !== 'pop_time'
        )
        // Yuck. But I don't immediately see a better way of filtering out the specific unit headers.
        selectedSecondaryHeaders.splice(3, 2)
    }

    // eslint-disable-next-line no-new
    new Table({
        id: tableDivId,
        repeatHeader,
        secondaryHeaders: selectedSecondaryHeaders,
        headers: selectedHeaders,
        highlightFalsy: false,
        data,
        uniqueId: 'catcher_id', // this can't have dashes in it
        defaultSort,
        defaultSortDirection,
        sortClass: 'column-sort',
        showRank: true,
        sortCallback(column, _, { state }) {
            const url = populateUrl(column, state)
            window.history.replaceState('', '', url)
        },
        subDataId: 'row_id',
    })
}

let expanded = false

if (data && data.length) {
    loadTable(currentData)

    const $input = document.querySelector('.table-search')

    if ($input) {
        $input.addEventListener('input', (e) => {
            currentData = getFilteredData(e.target.value)
            loadTable(currentData, expanded)
        })
    }
}

function showWithTeam(value) {
    if (is_team_type) {
        return
    }

    const display = ['', 'split'].includes(value) ? 'none' : 'inline-flex'
    document.getElementById('with-team-only-wrapper').style.display = display
}
document.querySelectorAll('.form-control').forEach((el) => {
    el.addEventListener('change', (e) => {
        const id = el.getAttribute('id')
        const type = id.slice(3)
        const { selectedIndex } = e.target
        document.querySelector(`.label-change-${type}`).innerText =
            e.target.value === 'split'
                ? 'All - Split by Team'
                : e.target[selectedIndex].text

        if (type === 'Team') {
            showWithTeam(e.target.value)
        }
    })
})

showWithTeam(team || '')

function populateUrl(sortColumn, sortDirection) {
    const parameters = {
        game_type: document.getElementById('ddlGameType').value,
        n: document.getElementById('ddlMinPitches').value,
        season_end: document.getElementById('ddlSeasonEnd').value,
        season_start: document.getElementById('ddlSeasonStart').value,
        split: document.getElementById('ddlSplitYears').value,
        team: document.getElementById('ddlTeam').value,
        type: document.getElementById('ddlGroup').value,
        with_team_only: document.getElementById('with-team-only').checked
            ? 1
            : 0,
        target_base: document.getElementById('ddlTargetBase')?.value,
    }

    if (sortColumn) {
        parameters.sortColumn = sortColumn
        document.getElementById('sort').value = sortColumn
    }

    if (sortDirection) {
        parameters.sortDirection = sortDirection
        document.getElementById('sortDir').value = sortDirection
    }

    const urlParams = new URLSearchParams(parameters)

    return `${window.location.pathname}?${urlParams.toString()}`
}

document.getElementById('btn-update').addEventListener('click', () => {
    window.location = populateUrl()
})

document.getElementById('btn-columns').addEventListener('click', () => {
    expanded = !expanded
    document.getElementById('btn-columns').innerText = expanded
        ? 'Show Fewer Columns'
        : 'Show More Columns'
    loadTable(currentData, expanded)
})

/* eslint-enable no-param-reassign */

function groupDataByEntity(
    catcherData,
    grouped_entity = 'pitcher_id',
    grouped_name = 'pitcher_name'
) {
    // Group by pitcher
    // const grouped_entity = `${entity}_id`
    // const grouped_name = `${entity}_name`
    const groupedMap = catcherData.reduce((acc, curr) => {
        if (!curr[grouped_entity] && !curr.is_throw_held) {
            return acc
        }

        if (!acc[curr[grouped_entity]]) {
            acc[curr[grouped_entity]] = []
        }

        acc[curr[grouped_entity]].push(curr)

        return acc
    }, {})

    const grouped = Object.values(groupedMap)
        .sort((a, b) => {
            if (b.length !== a.length) {
                return b.length - a.length
            }

            const nameA = a[0][grouped_name]

            if (nameA === null) {
                return -1
            }

            return a[0][grouped_name].localeCompare(b[0][grouped_name])
        })
        .filter(
            (d) =>
                grouped_entity === 'throw_type' ||
                (target_base === '2B' ? d.length > 1 : d.length >= 1) // Filter to exclude runners/fielders with 1 CS for 2B, includes them for 3B/All
        )
        .map((groupData) => {
            // Sum SBA
            const sba = groupData.length
            // Average Est CS
            const avgEstCS = groupData.reduce(
                (acc, curr) => curr.exp_cs / sba + acc,
                0
            )

            // Sum CS
            const cs = groupData.filter((d) => d.is_runner_cs === 1).length

            // CSAA
            const csaa = groupData.reduce((acc, curr) => curr.cs_aa + acc, 0)

            let entity_name = groupData[0][grouped_name]

            if (grouped_entity === 'fielder_id' && !entity_name) {
                entity_name = '<em>No Throw</em>'
            }
            return {
                entity_id: groupData[0][grouped_entity],
                entity_name,
                est_cs: avgEstCS,
                sba,
                cs,
                csaa,
                cs_pct: cs / sba,
            }
        })

    return grouped
}

function displayFnFixed(digits) {
    return function displayFn(val) {
        return val !== undefined && val !== null ? val.toFixed(digits) : '--'
    }
}

const displayFn2 = displayFnFixed(2)

function lastNameFirstInitial(name) {
    const [last, first] = name.split(', ')
    return `${last}, ${first[0]}.`
}

function createAllAttemptsTable($wrapper, id, data) {
    const $tabWrapper = document.createElement('div')
    $tabWrapper.classList.add('all-tab-pane')
    $tabWrapper.classList.add('tab-pane')
    $tabWrapper.classList.add('active')

    const $h3All = document.createElement('h3')
    $h3All.innerText = 'All Stolen Base Attempts'
    $h3All.style.marginBottom = '10px'

    const $allTableDiv = document.createElement('div')
    $allTableDiv.id = `all_${id}`

    $tabWrapper.appendChild($h3All)
    $tabWrapper.appendChild($allTableDiv)

    $wrapper.appendChild($tabWrapper)

    // eslint-disable-next-line no-new
    new Table({
        id: $allTableDiv.id,
        data,
        sortClass: 'column-sort',
        secondaryHeaders: [
            {
                name: '',
                colspan: 9,
                headerClass: 'th-name-header',
            },
            {
                name: `
                    <div style="white-space: normal; font-weight: normal; text-align: left;">
                        <strong>What's this??</strong> <em>Each play's Catcher's CS Above Avg can be broken down into credit for different skills. "Teamwork" refers to value that can't be assigned directly to a catcher -- which may imply great tags or missed slides. <a href="http://tangotiger.com/index.php/site/article/statcast-lab-cs-accuracy-model" target="_blank">Learn more.</a></em>
                    </div>
                    <br />
                    <div>Catcher's CS Above Average Breakdown</div>`,
                colspan: 6,
                headerClass: 'th-title-header darker-border-bottom',
            },
            {
                name: '',
                colspan: 1,
                headerClass: 'th-name-header',
            },
        ],
        headers: [
            {
                name: 'Date',
                field: 'game_date',
                headerClass:
                    'th-component-header align-center th-vertical-bottom',
                fieldClass: 'tr-data align-center',
                displayFn: (val) => val.slice(0, 10),
            },
            {
                name: 'Catcher <br/>Name',
                field: 'catcher_name',
                headerClass:
                    'th-component-header align-left th-vertical-bottom',
                fieldClass: 'tr-data align-left',
                displayFn: lastNameFirstInitial,
            },
            {
                name: 'Pitcher <br/>Name',
                field: 'pitcher_name',
                headerClass:
                    'th-component-header align-left th-vertical-bottom',
                fieldClass: 'tr-data align-left',
                displayFn: (value, { pitch_hand }) => {
                    const hand = pitch_hand
                        ? ` <span class="search-label">(${pitch_hand})</span>`
                        : ''
                    return lastNameFirstInitial(value) + hand
                },
            },
            {
                name: 'Runner <br/>Name',
                field: 'runner_name',
                headerClass:
                    'th-component-header align-left th-vertical-bottom',
                fieldClass: 'tr-data align-left',
                displayFn: lastNameFirstInitial,
            },
            {
                name: 'Fielder <br/>Name',
                field: 'fielder_name',
                headerClass:
                    'th-component-header align-left th-vertical-bottom',
                fieldClass: 'tr-data align-left',
                displayFn: (val, row) => {
                    if (val) {
                        return lastNameFirstInitial(val)
                    }

                    if (row.is_throw_held) {
                        return '<em>No Throw</em>'
                    }

                    return '--'
                },
            },
            {
                name: 'Throw <br/> Type',
                field: 'throw_type',
                headerClass:
                    'th-component-header align-center th-vertical-bottom',
                fieldClass: 'tr-data align-center',
            },
            {
                name: 'Base',
                field: 'target_base',
                headerClass:
                    'th-component-header align-center th-vertical-bottom',
                fieldClass: 'tr-data align-center',
            },
            {
                name: 'Result',
                field: 'is_runner_cs',
                headerClass:
                    'th-component-header align-center th-vertical-bottom',
                fieldClass: 'tr-data align-center',
                displayFn: (value) => (value ? 'CS' : 'SB'),
            },
            {
                name: 'Est. <br/>CS%',
                field: 'exp_cs',
                headerClass:
                    'th-component-header align-center th-vertical-bottom',
                fieldClass: 'tr-data align-center',
                type: 'number',
                displayFn: (value) => `${Math.round(value * 100)}%`,
            },
            {
                name: "Catcher's <br/>CS Above<br/> Average",
                field: 'cs_aa',
                headerClass:
                    'th-component-header drawer-catchers-cs-aa-header align-center th-vertical-middle darker-border-left component-col',
                fieldClass:
                    'tr-data align-right drawer-catchers-cs-aa-cell darker-border-left dotted-border-right component-col',
                type: 'number',
                displayFn: displayFn2,
            },
            {
                name: 'Throw <br/>Speed',
                field: 'flight_over_xcs',
                headerClass:
                    'th-component-header align-center th-vertical-middle equal-sign component-col',
                fieldClass: 'tr-data component-col',
                type: 'number',
                displayFn: displayFn2,
                toolTip:
                    'The caught stealing above average value attributed to the catcher’s arm strength compared to the expectation of an average catcher.',
            },
            {
                name: 'Exchange',
                field: 'exchange_over_xcs',
                headerClass:
                    'th-component-header align-center th-vertical-middle plus-sign component-col',
                fieldClass: 'tr-data component-col',
                type: 'number',
                displayFn: displayFn2,
                toolTip: `The caught stealing above average value attributed to the catcher’s exchange time compared to the expectation of an average catcher.
            The exchange time is the time between the catcher receiving the pitch and releasing his throw.`,
            },
            {
                name: 'Accuracy',
                field: 'accuracy_over_xcs',
                headerClass:
                    'th-component-header align-center th-vertical-middle plus-sign component-col',
                fieldClass: 'tr-data component-col',
                type: 'number',
                displayFn: displayFn2,
                toolTip:
                    'The caught stealing above average value attributed to the catcher’s accuracy compared to the expectation of an average catcher.',
            },
            {
                name: 'Teamwork',
                field: 'teamwork_over_xcs',
                headerClass:
                    'th-component-header align-center th-vertical-middle plus-sign component-col',
                fieldClass: 'tr-data component-col',
                type: 'number',
                displayFn: displayFn2,
                toolTip:
                    'The caught stealing above average value on throws which cannot be attributed to the catcher’s arm strength, exchange time, or accuracy compared to the expectation of an average catcher.',
            },
            {
                name: 'Not <br/> Tracked',
                field: 'untracked_other_over_xcs',
                headerClass:
                    'th-component-header align-center th-vertical-middle plus-sign border-right component-col',
                fieldClass: 'tr-data border-right component-col',
                type: 'number',
                displayFn: displayFn2,
                toolTip:
                    'The caught stealing above average value on stolen base attempts in which we were unable to track the catcher’s throw.',
            },
            {
                name: '',
                field: 'entity_id',
                headerClass:
                    'th-component-header align-center th-vertical-bottom video-col cursor-initial',
                fieldClass: 'tr-data video-col',
                type: 'number',
                sortable: false,
                displayFn: (value, { play_id }) => `
                            <a href="/sporty-videos?playId=${play_id}" target="_BLANK">
                                <img src="/site-core/images/video.png" style="margin-right: 4px; width: 25px; height: 13px; cursor: pointer;">
                            </a>
                           `,
            },
        ],
        defaultSort: 'game_date',
        defaultSortDirection: 'asc',
    })
}
function createGroupedTable($wrapper, id, groupedData, title, slug) {
    // $wrapper > $tabWrapper > ($h3Grouped + $groupedSubTitleDiv + $groupedTableDiv)
    const $tabWrapper = document.createElement('div')
    $tabWrapper.classList.add(`${slug}-tab-pane`)
    $tabWrapper.classList.add('tab-pane')

    const $h3Grouped = document.createElement('h3')
    // capitalize first letter
    $h3Grouped.innerText = `${title} Summary`
    $h3Grouped.style.marginBottom = 0

    const $groupedSubTitleDiv = document.createElement('div')
    $groupedSubTitleDiv.innerText =
        slug !== 'throw_type' && target_base === '2B'
            ? 'Minimum 2 Attempts'
            : ''
    $groupedSubTitleDiv.style.marginBottom = '10px'
    $groupedSubTitleDiv.style.fontStyle = 'italic'

    const $groupedTableDiv = document.createElement('div')
    $groupedTableDiv.id = `${slug}_${id}`

    $tabWrapper.appendChild($h3Grouped)
    $tabWrapper.appendChild($groupedSubTitleDiv)
    $tabWrapper.appendChild($groupedTableDiv)

    $wrapper.appendChild($tabWrapper)

    // eslint-disable-next-line no-new
    new Table({
        id: $groupedTableDiv.id,
        data: groupedData,
        sortClass: 'column-sort',
        headers: [
            {
                name: 'Player',
                field: 'entity_name',
                headerClass:
                    'th-component-header align-left th-vertical-bottom',
                fieldClass: 'tr-data align-left',
            },
            {
                name: 'SB Attempts',
                field: 'sba',
                headerClass:
                    'th-component-header align-center th-vertical-bottom',
                fieldClass: 'tr-data',
                type: 'number',
            },
            {
                name: 'CS',
                field: 'cs',
                headerClass:
                    'th-component-header align-center th-vertical-bottom',
                fieldClass: 'tr-data',
                type: 'number',
            },
            {
                name: 'CS %',
                field: 'cs_pct',
                headerClass:
                    'th-component-header align-center th-vertical-bottom',
                fieldClass: 'tr-data',
                type: 'number',
                displayFn: (val) =>
                    val !== undefined && val !== null
                        ? `${Math.round(val * 100)}%`
                        : '',
            },
            {
                name: 'Estimated CS%',
                field: 'est_cs',
                headerClass:
                    'th-component-header align-center th-vertical-bottom',
                fieldClass: 'tr-data',
                type: 'number',
                displayFn: (val) =>
                    val !== undefined && val !== null
                        ? `${Math.round(val * 100)}%`
                        : '',
            },
            {
                name: "Catcher's <br />CS Above Average",
                field: 'csaa',
                headerClass:
                    'th-component-header align-center th-vertical-bottom',
                fieldClass: 'tr-data',
                type: 'number',
                displayFn: (val) => Math.round(val),
            },
        ],
        defaultSort: 'sba',
        defaultSortDirection: 'desc',
    })
    return $tabWrapper
}

function handleButtonClick($button) {
    // all buttons
    $button
        .closest('.drawer-tabs')
        .querySelectorAll('.drawer-nav')
        .forEach(($el) => {
            $el.classList.remove('active')
        })

    // add active button
    $button.classList.add('active')

    // all tabs
    const $drawer = $button.closest('.throwing-drawer')

    $drawer.querySelectorAll('.tab-pane').forEach(($el) => {
        $el.classList.remove('active')
    })

    $drawer
        .querySelector(`.${$button.dataset.tab}-tab-pane`)
        .classList.add('active')
}

document.getElementById(tableDivId).addEventListener('click', async (e) => {
    const $a = e.target.closest('a')

    if ($a) {
        return
    }

    const $el = e.target.closest('tr.default-table-row')
    const $button = e.target.closest('.drawer-nav')

    if (!$el && !$button) {
        return
    }

    if ($button) {
        handleButtonClick($button)
        return
    }

    const id = `data_${$el.dataset.id}`
    const $innerDiv = document.getElementById(id)

    const $sub = $el.nextSibling

    const isOpen = $sub.dataset.open === 'true'

    const $videoIcon = $el.querySelector('[data-video-icon]')

    if (!$videoIcon) {
        return
    }

    // Close drawer
    if ($innerDiv && isOpen) {
        slideUp($innerDiv, 400)
        $sub.dataset.open = 'false'
        $videoIcon.style.backgroundColor = 'white'
        // $sub.style.display = 'none'
        return
    }

    // Open drawer color
    $videoIcon.style.backgroundColor = '#797979'

    // Open Drawer
    if ($innerDiv && !isOpen) {
        slideDown($innerDiv, 400)
        $sub.dataset.open = 'true'
        return
    }

    const $td = $sub.querySelector('td')

    const params = new URLSearchParams(window.location.search)

    // Eww.
    const [entity_id, year, team_id] = $el.dataset.id.split('_')

    params.set(
        'season_start',
        splitYears ? year : params.get('season_start') || ''
    )
    params.set('season_end', splitYears ? year : params.get('season_end') || '')
    params.set('team', team === 'split' ? team_id : params.get('team') || '')

    const $wrapperDiv = document.createElement('div')

    $wrapperDiv.classList.add('throwing-drawer')
    $wrapperDiv.textContent = 'Loading...'
    // NO DASHES ALLOWED!
    $wrapperDiv.id = id

    $sub.style.display = 'table-row'
    $sub.dataset.open = 'true'

    $td.appendChild($wrapperDiv)

    // Fetches data for dropdown table (detailed catcher play-by-play throwing data)
    const url = `/leaderboard/services/catcher-throwing/${entity_id}?${params.toString()}`

    const { data } = await fetch(url).then((res) => res.json())

    $wrapperDiv.style.display = 'none'
    $wrapperDiv.textContent = ''

    $wrapperDiv.innerHTML = `
    <div class="drawer-tabs">
        <button data-tab="all" class="tab-all drawer-nav active" >
            All Attempts
        </button>
        <button data-tab="catcher_id" class="tab-catcher drawer-nav" style="display: ${
            entity_code !== 'Cat' ? 'block' : 'none'
        }">
            Catchers
        </button>
        <button data-tab="fielder_id" class="tab-fielder drawer-nav" >
            Fielders
        </button>
        <button data-tab="pitcher_id" class="tab-pitcher drawer-nav" >
            Pitchers
        </button>
        <button data-tab="runner_id" class="tab-runner drawer-nav" >
            Runners
        </button>
        <button data-tab="throw_type" class="tab-runner drawer-nav" >
            Throw Types
        </button>
    </div>
    `

    const entities = [
        {
            group_entity_id: 'catcher_id',
            name: 'catcher_name',
            title: 'Catcher',
        },
        {
            group_entity_id: 'pitcher_id',
            name: 'pitcher_name',
            title: 'Pitcher',
        },
        {
            group_entity_id: 'fielder_id',
            name: 'fielder_name',
            title: 'Fielder',
        },
        { group_entity_id: 'runner_id', name: 'runner_name', title: 'Runner' },
        {
            group_entity_id: 'throw_type',
            name: 'throw_type',
            title: 'Throw Type',
        },
    ]

    entities
        .map(({ group_entity_id, name, title }) => ({
            group_entity_id,
            name,
            title,
            grouped: groupDataByEntity(data, group_entity_id, name),
        }))
        .forEach(({ group_entity_id, title, grouped }) => {
            if (
                grouped.length &&
                (entity_id !== 'catcher_id' || entity_code !== 'Cat')
            ) {
                createGroupedTable(
                    $wrapperDiv,
                    id,
                    grouped,
                    title,
                    group_entity_id
                )
            } else {
                $wrapperDiv
                    .querySelector(`[data-tab="${group_entity_id}"]`)
                    .classList.add('hide')
            }
        })

    createAllAttemptsTable($wrapperDiv, id, data)

    slideDown($wrapperDiv, 400)
})

function getFilteredData(search) {
    const normalized_search = search
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()

    return data.filter((d) => {
        const name = d.entity_name
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()

        return name.includes(normalized_search)
    })
}

document.getElementById('btn-csv').addEventListener('click', () => {
    window.location.href = window.location.search
        ? `${window.location.href}&csv=true`
        : `${window.location.href}?csv=true`
})
